import Vue from 'vue';
import VueSelect from 'vue-select';
import '@/scss/bundles/v-select.scss';
import 'vue-select/dist/vue-select.css';

Vue.component('VueSelect', VueSelect);

export default VueSelect;
